import React from 'react';

import Grid from "@mui/material/Grid";

import SandboxField from "../components/SandboxField";

function ColissimoViaToopost(props) {
    return (
        <Grid container>
            <Grid item xs={12}>
                <SandboxField />
            </Grid>
        </Grid>
    );
}

export default ColissimoViaToopost;
